import { makeStyles } from '@material-ui/core';

export const css = makeStyles(() => ({
  main: {
    margin: '0 30px',
    display: 'flex',
    flexDirection: 'column',
    gridGap: '24px'
  }
}));
